<template>
  <div class="btn">
    <TagLock class="btn__icon" v-if="!hasPaidAccount"/>
    <LoaderPlug v-if="isLoadingUserData" />
    <template v-else>
      <transition name="fade-scale" mode="out-in">
        <UserStackWithNotifications 
          v-if="notificationsCount > 0 && hasPaidAccount" 
          @click="toToggle" 
          key="with-notifications"
        />
        <DefaultCallButton 
          v-else 
          @click="toToggle" 
          :isActive="isOpen"
          key="default-button"
        />
      </transition>
    </template>
  </div>
</template>

<script setup>
  import { useNotificationsDropdown } from '@/Groups/Notifications/private/imports/toggleDropdown';
  import { useNotificationsState } from '@/Groups/Notifications/private/composables/computedValues';
  import { useUserAuth } from '@/Groups/Notifications/private/imports/userStoreData';
  //-----------------------------------
  import LoaderPlug from '@/Groups/Notifications/private/ui/LoaderPlug/LoaderPlug.vue';
  import { TagLock } from '@/Groups/Audioplayer/private/imports/externalTemplates';
  import UserStackWithNotifications from '@/Groups/Notifications/private/core/UserStackWithNotifications/UserStackWithNotifications.vue';
  import DefaultCallButton from '@/Groups/Notifications/private/ui/DefaultCallButton/DefaultCallButton.vue';
  //-----------------------------------
  const { notificationsCount } = useNotificationsState();
  //-----------------------------------
  const { hasPaidAccount, isLoadingUserData } = useUserAuth();
  //-----------------------------------
  const { open, isOpen, close } = useNotificationsDropdown();
  //-----------------------------------
  //Открыть попап
  const toToggle = () => { 
    if(!hasPaidAccount.value) return;
    isOpen.value ? close() : open();
  }
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>
